import {Injectable} from '@angular/core';
import {TlPagination} from '../../interfaces/general-interfaces';

@Injectable({
  providedIn: 'root'
})
export class GeneralHttpHelperService {

  constructor() {
  }

  returnPagination(response: any): TlPagination {
    return {
      currentPage: response.current_page,
      totalItems: response.total,
      perPage: response.per_page,
      nextPageUrl: response.next_page_url,
      to: response.to,
      from: response.from,
      lastPage: response.last_page
    };
  }

  addUrlParams(url?: string, params?: Record<string, any>): string {
    const paramsPairs: any[] = [];
    for (const key in params) {
      if (typeof params[key] === 'object' && params[key] !== null && params[key] !== '' && params[key] !== undefined) {
        for (const itemKey in params[key]) {
          paramsPairs.push(`${key}[${itemKey}]=${params[key][itemKey]}`);
        }
      } else if (params[key] !== null && params[key] !== '' && params[key] !== undefined) {
        paramsPairs.push(`${key}=${params[key]}`);
      }
    }

    return `${url}?${paramsPairs.join('&')}`;
  }

  replaceUrlParamsWithValues(url: string, params: Record<string, any>): string {
    let newUrl = url;
    for (const key in params) {
      newUrl = newUrl.replace(`:${key}`, params[key]);
    }
    return newUrl;
  }

  generateRandomState() {
    return Math.random().toString(36).substring(2);
  }

  generateRandomNonce() {
    return Math.random().toString(36).substring(2);
  }
}
